import React from "react";
import "./style.scss";
import Particles from "./img/story-points-particles.png";
import Bonus from "./img/bonusPkt.png";

export default function StoryPoints({ children, fill, animate, bonus }) {
  return (
    <div className={`story-points-component ${animate ? "animate" : ""}`}>
      <img className="particles" src={Particles} alt="particles" />
      <div className="bg-fill">
        <div className="bg-fill-inner" style={{ height: `${fill}%` }}></div>
      </div>
      <p>
        <span>+{children}</span>
        <br />
        <span className="points">Punkte</span>
      </p>
      {bonus > 0 && (
        <div className="bonus-value">
          <img className="bonus-img" src={Bonus} alt={bonus} />
          <div className="bonus-prize">
            <div className="bonus-inner">
              +{bonus}
              <span className="bonus-prize-copy">Punkte</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
